document.addEventListener("DOMContentLoaded", function () {
  // ===== Utility Functions =====
  const utils = {
    calculateAdjustedQuantity: function (quantity, extraTenPercent) {
      return extraTenPercent ? Math.ceil(quantity * 1.1) : quantity;
      console.log(extraTenPercent);
    },
    formatNumber: function (number) {
      return number.toFixed(2);
    },
    log: function (message, data) {
      console.log(`[coverage-calculator] ${message}`, data);
    },
    fetchCart: function () {
      return fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((cart) => {
          utils.log("Current cart fetched:", cart);
          return cart;
        })
        .catch((error) => {
          console.error("Error fetching cart:", error);
          return null;
        });
    },
  };

  // ===== Elements =====
  const elements = {
    calculator: document.querySelector(".coverage-calculator"),
    accordionToggle: document.querySelector(".accordion-toggle"),
    accordionContent: document.querySelector(".accordion-content"),
    quantity: null,
    minusButton: null,
    plusButton: null,
    extraTenPercentCheckbox: null,
    totalCoverageSpan: null,
    totalPriceSpan: null,
    addToCartButton: null,
    productIdInput: document.querySelector('input[name="selected-product-id"]'),
    priceElement: document.querySelector(".price-item--regular"),
    coverageElement: document.querySelector(".courage_price span"),
  };

  // Initialize nested elements
  if (elements.calculator) {
    elements.quantity = elements.calculator.querySelector(
      "#coverageCalculatorQuantity"
    );
    elements.minusButton = elements.calculator.querySelector(
      "#coverageCalculatorQuantityMinus"
    );
    elements.plusButton = elements.calculator.querySelector(
      "#coverageCalculatorQuantityPlus"
    );
    elements.extraTenPercentCheckbox = elements.calculator.querySelector(
      "#coverageCalculatorExtraTenPercent"
    );
    elements.totalCoverageSpan = elements.calculator.querySelector(
      "#coverageCalculatorTotalCoverage"
    );
    elements.totalPriceSpan = elements.calculator.querySelector(
      "#coverageCalculatorTotalPrice"
    );
    elements.addToCartButton = elements.calculator.querySelector(
      "#coverageCalculatorAddToCart"
    );
  }

  // ===== Constants =====
  const constants = {
    productId: elements.productIdInput
      ? Number(elements.productIdInput.value)
      : null,
    price:
      parseFloat(
        elements.priceElement.getAttribute("cust_prc").replace("£", "")
      ) || 0,
    coveragePerPack: parseFloat(elements.coverageElement.textContent) || 0,
  };

  utils.log("Initialized constants:", constants);



  const corePercentageFunctions = {
    updatePercentageCalculations: function () {
      let quantity = parseInt(elements.quantity.value) || 1;
      const extraTenPercent = elements.extraTenPercentCheckbox.checked;

      // Set minimum quantity based on extra 10% checkbox
      const minQuantity = extraTenPercent ? 1 : 1;
      if (quantity < minQuantity) {
        quantity = minQuantity;
        elements.quantity.value = minQuantity;
      }

      const adjustedQuantity = utils.calculateAdjustedQuantity(
        quantity
      );
      const baseCoverage = adjustedQuantity * constants.coveragePerPack;
      const basePrice = adjustedQuantity * constants.price;


      const tileCoverageSpan = document.getElementById("tilecoverageCalculator");
      const coveragePerTile = parseFloat(tileCoverageSpan.dataset.coverage) || 1;
      const tilesRequired = (quantity / coveragePerTile) * 1.1; 
        if (tileCoverageSpan) {
          tileCoverageSpan.textContent = utils.formatNumber(tilesRequired);
          elements.addToCartButton.querySelector("span").textContent = `Add ${utils.formatNumber(tilesRequired)} to Cart`;
        }
       const actualTileNumber = Math.ceil(utils.formatNumber(tilesRequired));
       const coverage = actualTileNumber * coveragePerTile ;    // Adds 10%
       const totalPrice = actualTileNumber * constants.price ;       // Adds 10%
      

      utils.log("Calculation update 2:", {
        quantity,
        extraTenPercent,
        adjustedQuantity,
        coverage,
        totalPrice,
      });

      elements.totalCoverageSpan.textContent = utils.formatNumber(coverage);
      elements.totalPriceSpan.textContent = utils.formatNumber(totalPrice);
      // elements.addToCartButton.querySelector(
      //   "span"
      // ).textContent = `Add ${quantity} to Cart`;

    },

    updateQuantity: function (change) {
      let currentQuantity = parseInt(elements.quantity.value) || 1;
      const minQuantity = elements.extraTenPercentCheckbox.checked ? 1 : 1;
      const newQuantity = Math.max(minQuantity, currentQuantity + change);
      elements.quantity.value = newQuantity;

      console.log("testing");
      coreFunctions.updateCalculations();
    },

    addToCart: function (quantity, productId) {
      utils.fetchCart().then((cart) => {
        if (!cart) {
          utils.log("Failed to fetch cart. Cannot proceed with add/update.");
          return;
        }

        const existingItem = cart.items.find(
          (item) => item.id === parseInt(productId)
        );
        let endpoint, method, body;

        if (existingItem) {
          endpoint = window.Shopify.routes.root + "cart/change.js";
          method = "POST";
          body = JSON.stringify({
            id: existingItem.key,
            quantity: existingItem.quantity + quantity,
          });
          utils.log("Updating existing cart item:", {
            itemKey: existingItem.key,
            oldQuantity: existingItem.quantity,
            addedQuantity: quantity,
            newQuantity: existingItem.quantity + quantity,
          });
        } else {
          endpoint = window.Shopify.routes.root + "cart/add.js";
          method = "POST";
          body = JSON.stringify({
            items: [{ id: productId, quantity: quantity }],
          });
          utils.log("Adding new item to cart:", { productId, quantity });
        }

        fetch(endpoint, {
          method: method,
          headers: { "Content-Type": "application/json" },
          body: body,
        })
          .then((response) => response.json())
          .then((data) => {
            utils.log("Cart updated successfully:", data);
            const customEvent = new CustomEvent(
              "coverageCalculatorAddedToCart",
              {
                detail: { productId: productId, quantity: quantity },
              }
            );
            document.dispatchEvent(customEvent);
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
          });
      });
    },
  };





  // ===== Core Functions =====
  const coreFunctions = {
    updateCalculations: function () {
      let quantity = parseInt(elements.quantity.value) || 1;
      const extraTenPercent = elements.extraTenPercentCheckbox.checked;

      // Set minimum quantity based on extra 10% checkbox
      const minQuantity = extraTenPercent ? 1 : 1;
      if (quantity < minQuantity) {
        quantity = minQuantity;
        elements.quantity.value = minQuantity;
      }

      const adjustedQuantity = utils.calculateAdjustedQuantity(
        quantity
      );
      
      const baseCoverage = adjustedQuantity * constants.coveragePerPack;
      const basePrice = adjustedQuantity * constants.price;

       let coverage = baseCoverage;    // Adds 10%

      let totalPrice;

     const tileCoverageSpan = document.getElementById("tilecoverageCalculator");

          if (tileCoverageSpan) {
            const coveragePerTile = parseFloat(tileCoverageSpan.dataset.coverage) || 1;
            let tilesRequired;
            if (extraTenPercent) {
            tilesRequired = (quantity / coveragePerTile)*1.1;
            }else{
              tilesRequired = quantity / coveragePerTile;
            }
            const actualTileNumber = Math.ceil(utils.formatNumber(tilesRequired));
            totalPrice = actualTileNumber * constants.price; 
            coverage = actualTileNumber * coveragePerTile;
             
            
            tileCoverageSpan.textContent = utils.formatNumber(tilesRequired);
            elements.addToCartButton.querySelector("span").textContent = `Add ${utils.formatNumber(tilesRequired)} to Cart`;
          }



     
            
   
  

      utils.log("Calculation update1:", {
        quantity,
        extraTenPercent,
        adjustedQuantity,
        coverage,
        totalPrice,
      });

      elements.totalCoverageSpan.textContent = utils.formatNumber(coverage);
      elements.totalPriceSpan.textContent = utils.formatNumber(totalPrice);
      // elements.addToCartButton.querySelector(
      //   "span"
      // ).textContent = `Add ${quantity} to Cart`;
      
    },

    updateQuantity: function (change) {
      let currentQuantity = parseInt(elements.quantity.value) || 1;
      const minQuantity = elements.extraTenPercentCheckbox.checked ? 1 : 1;
      const newQuantity = Math.max(minQuantity, currentQuantity + change);
      elements.quantity.value = newQuantity;
      coreFunctions.updateCalculations();
    },

    addToCart: function (quantity, productId) {
      utils.fetchCart().then((cart) => {
        if (!cart) {
          utils.log("Failed to fetch cart. Cannot proceed with add/update.");
          return;
        }

        const existingItem = cart.items.find(
          (item) => item.id === parseInt(productId)
        );
        let endpoint, method, body;

        if (existingItem) {
          endpoint = window.Shopify.routes.root + "cart/change.js";
          method = "POST";
          body = JSON.stringify({
            id: existingItem.key,
            quantity: existingItem.quantity + quantity,
          });
          utils.log("Updating existing cart item:", {
            itemKey: existingItem.key,
            oldQuantity: existingItem.quantity,
            addedQuantity: quantity,
            newQuantity: existingItem.quantity + quantity,
          });
        } else {
          endpoint = window.Shopify.routes.root + "cart/add.js";
          method = "POST";
          body = JSON.stringify({
            items: [{ id: productId, quantity: quantity }],
          });
          utils.log("Adding new item to cart:", { productId, quantity });
        }

        fetch(endpoint, {
          method: method,
          headers: { "Content-Type": "application/json" },
          body: body,
        })
          .then((response) => response.json())
          .then((data) => {
            utils.log("Cart updated successfully:", data);
            const customEvent = new CustomEvent(
              "coverageCalculatorAddedToCart",
              {
                detail: { productId: productId, quantity: quantity },
              }
            );
            document.dispatchEvent(customEvent);
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
          });
      });
    },
  };

  // ===== Event Listeners =====
  function setupEventListeners() {
    if (elements.accordionToggle && elements.accordionContent) {
      elements.accordionToggle.addEventListener("click", function (e) {
        e.preventDefault();
        this.classList.toggle("active");
        elements.accordionContent.classList.toggle("active");
        utils.log("Accordion toggled");
      });
    }

    elements.quantity.addEventListener("input", function () {
      const minQuantity = elements.extraTenPercentCheckbox.checked ? 1 : 1;
      if (parseInt(this.value) < minQuantity) {
        this.value = minQuantity;
      }
      coreFunctions.updateCalculations();
    });

    elements.extraTenPercentCheckbox.addEventListener("change", function () {
      const minQuantity = this.checked ? 1 : 1;
      let currentQuantity = parseInt(elements.quantity.value) || 1;
      let newQuantity;
      if (this.checked) {
        // Ticking: add 1
        newQuantity = currentQuantity + 1;
       corePercentageFunctions.updatePercentageCalculations();
      } else {
        // Unticking: reduce by 1, but not below min
        newQuantity = Math.max(minQuantity, currentQuantity - 1);
       coreFunctions.updateCalculations();
      }
  

    });

    
if(elements.minusButton){
    elements.minusButton.addEventListener("click", (e) => {
      e.preventDefault();
      coreFunctions.updateQuantity(-1);
    });
  }
  if(elements.plusButton){
    elements.plusButton.addEventListener("click", (e) => {
      e.preventDefault();
      coreFunctions.updateQuantity(1);
    });
  }

      elements.addToCartButton.addEventListener("click", function (e) {
            e.preventDefault();
            console.log('ready');
            
            // 1. Get the current button text (e.g., "Add 12 to Cart")
            const buttonText = elements.addToCartButton.querySelector("span").textContent;
            
            // 2. Use a regular expression to extract the number from the text
            const match = buttonText.match(/Add (\d+) to Cart/);
            
            // 3. The calculated quantity is the captured group (index 1)
            const quantity = match ? parseInt(match[1]) : 0; 
            
            if (quantity > 0 && constants.productId) {
              console.log('working');
              // Now, we pass the extracted tile count quantity to the function
              coreFunctions.addToCart(quantity, constants.productId); 
            } else {
              console.log('notworking');
              utils.log("Invalid add to cart attempt:", {
                quantity,
                productId: constants.productId,
              });
            }
          });
  }

  // ===== Initialization =====
  function init() {
    if (!elements.calculator) {
      utils.log("Calculator element not found. Exiting.");
      return;
    }
    setupEventListeners();

  // Checkbox is already checked by default in HTML, so trigger the calculation that includes 10%
  corePercentageFunctions.updatePercentageCalculations();
    
    


    utils.log("Coverage calculator initialized");
  }

  init();


  const input = document.getElementById('coverageCalculatorQuantity');

  input.addEventListener('input', function () {
    // Remove anything after a decimal point
    this.value = this.value.replace(/\..*/, '');
  });

  input.addEventListener('keypress', function (e) {
    if (e.key === '.' || e.key === ',') {
      e.preventDefault(); // Prevent typing decimal point
    }
  });

});


 document.addEventListener("DOMContentLoaded", function () {
    const input = document.getElementById("coverageCalculatorQuantity");
    const outputSpan = document.getElementById("tilecoverageCalculator");
    const checkbox = document.getElementById("coverageCalculatorExtraTenPercent");
    const button = document.getElementById("coverageCalculatorAddToCart");
    const coveragePerTile = parseFloat(outputSpan.dataset.coverage);

    function updateTileCount() {
      const area = parseFloat(input.value);
      const includeExtra = checkbox.checked;

      if (!isNaN(area) && area > 0 && !isNaN(coveragePerTile) && coveragePerTile > 0) {
        const totalArea = includeExtra ? area * 1.1 : area;
        const tilesRequired = Math.ceil(totalArea / coveragePerTile);

        // Update the tile count in span
        outputSpan.textContent = tilesRequired + " Tiles";

        // Update the button text
        const buttonText = `Add ${tilesRequired} to Cart`;
        button.querySelector("span").textContent = buttonText;
      } else {
        outputSpan.textContent = "-";
        button.querySelector("span").textContent = "Add to Cart";
      }
    }

    // Initial update
    updateTileCount();

    // Bind events
    input.addEventListener("input", updateTileCount);
    checkbox.addEventListener("change", updateTileCount);
  });